<template>
  <v-container>
    <v-layout row wrap>
      <v-flex md8>
        <h4 class="headline mb-4 mt-2">
          {{ workflow.name }}
        </h4>
      </v-flex>
      <v-flex md4 class="text-xs-right">
        <v-btn class="k-orange-linear mr-0" @click="createStage">
          Crear etapa
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <stages-list
          :stages="stages"
          @select-stage="selectedStageId = $event.id"
          @commute-stage="commuteStage"
          @edit-stage="editStage"
          @delete-stage="deleteStage"
          @commute-filter="commuteFilter"
          @create-filter="createFilter"
          @edit-filter="editFilter"
          @delete-filter="deleteFilter" />
      </v-flex>
    </v-layout>
    <stage-modal
      :show="stageModal"
      :stage="selectedStage"
      @created="$emit('stage-created', $event)"
      @updated="$emit('stage-updated', $event)"
      @close="stageModal = false"/>
    <filter-modal
      :show="filtersModal"
      :stage="selectedStage"
      :filter="selectedFilter"
      @created="$emit('filter-created', selectedStage, $event)"
      @updated="$emit('filter-updated', selectedStage, $event)"
      @close="filtersModal = false" />
    <delete-dialog
      :show="deleteModal"
      :url="deleteUrl"
      :message="deleteMessage"
      @deleted="deletedEvt"
      @close="deleteModal = false"/>
  </v-container>
</template>

<script>
import _ from 'lodash';
import StageModal from '@/components/CollectWorkflows/Detail/WorkflowTree/StageModal';
import StagesList from '@/components/CollectWorkflows/Detail/WorkflowTree/StagesList';
import FilterModal from '@/components/CollectWorkflows/Detail/WorkflowTree/FilterModal';
import DeleteDialog from '@/components/global/DeleteDialog2';

export default {
  props: {
    workflow: {
      type: Object,
      required: true,
    },
    stages: {
      type: Array,
      required: true,
    },
  },
  components: {
    StageModal,
    StagesList,
    FilterModal,
    DeleteDialog,
  },
  data() {
    return {
      stageModal: false,
      filtersModal: false,
      selectedStageId: 0,
      selectedFilter: {},
      deleteModal: false,
      deleteType: 'stage',
    };
  },
  computed: {
    selectedStage() {
      return this.stages.find(item => item.id === this.selectedStageId) || {};
    },
    deleteUrl() {
      let url = '';
      if (this.deleteType === 'stage') {
        url = `stages/${this.selectedStage.id}`;
      } else {
        url = `v2/workflow_filters/${this.selectedFilter.id}`;
      }
      return url;
    },
    deleteMessage() {
      let message = '';
      if (this.deleteType === 'stage') {
        message = `¿Esta seguro de que desea eliminar la etapa días de mora ${this.selectedStage.delinquency_start} a ${this.selectedStage.delinquency_end}? Se borraran todos los filtros y plantillas asociadas. Esta acción es irreversible`;
      } else {
        message = `¿Esta seguro de que desea eliminar el filtro ${this.selectedFilter.name}? Se borraran todas las plantillas asociadas. Esta acción es irreversible`;
      }
      return message;
    },
  },
  methods: {
    createStage() {
      this.selectedStageId = 0;
      this.stageModal = true;
    },
    editStage(stage) {
      this.selectedStageId = stage.id;
      this.stageModal = true;
    },
    commuteStage(stage) {
      this.axios.patch(`stages/${stage.id}`, {
        status: stage.status === 'Activo' ? 'Inactivo' : 'Activo',
      }).then((response) => {
        this.$emit('stage-updated', response.data);
      }).catch(() => {});
    },
    deleteStage(stage) {
      this.selectedStageId = stage.id;
      this.deleteType = 'stage';
      this.deleteModal = true;
    },
    commuteFilter(filter) {
      this.axios.patch(`v2/workflow_filters/${filter.id}`, {
        status: filter.status === 'Activo' ? 'Inactivo' : 'Activo',
      }).then((response) => {
        this.$emit('filter-updated', this.selectedStage, response.data);
      }).catch(() => {});
    },
    createFilter(stage) {
      this.selectedStageId = stage.id;
      this.selectedFilter = {};
      this.filtersModal = true;
    },
    editFilter(filter) {
      const template = filter.template || {};
      const tmp = {
        ..._.pick(filter, [
          'id',
          'name',
          'order',
          'status',
          'bot_template_id',
          'send_human',
          'send_bot',
          'send_email',
          'send_sms',
          'send_ivr',
          'send_visit',
        ]),
        ..._.pick(template, [
          'company_email_id',
          'subject',
          'email',
          'sms',
          'ivr',
          'human',
          'visit',
        ]),
        template_id: template.id,
        filters: JSON.parse(filter.filters || '[]'),
      };
      this.selectedFilter = tmp;
      this.filtersModal = true;
    },
    deleteFilter(filter) {
      this.selectedFilter = filter;
      this.deleteType = 'filter';
      this.deleteModal = true;
    },
    deletedEvt() {
      this.deleteModal = false;
      this.$emit(`${this.deleteType}-deleted`, ...[
        this.selectedStage,
        ...this.deleteType === 'filter' && [
          this.selectedFilter,
        ],
      ]);
      if (this.deleteType === 'stage') {
        this.selectedStageId = 0;
      } else {
        this.selectedFilter = {};
      }
    },
  },
  watch: {
    filtersModal() {
      if (!this.filtersModal) {
        this.selectedFilter = {};
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/CollectWorkflows/Detail/WorkflowTree/Index.vue